import StartPage from '@/page/StartPage';

import SignInSns from '@/page/login/SignInSns';
import PortfolioMain from '@/page/portfolio/PortFolioMain';
import PoolMain from '@/page/pools/PoolMain';
import PortfolioDetail from '@/page/portfolio/PortfolioDetail';
import { SignIn } from '@/page/login/SignIn';
import Dashboard from '@/page/dashboard';
import AdminList from '@/page/admin-list';
import PoolList from '@/page/pool-list';
import CreateFactory from '@/page/create-factory';
import CreatePool from '@/page/create-pool';
import FactoryList from '@/page/factory-list';
import PoolDetail from '@/page/pool-detail';
import FactoryDetail from '@/page/factory-detail';
import SignUp from '@/page/login/SignUp';
import PoolRewardList from '@/page/pool-reward-list';
import Addresses from '@/page/addresses';
import PoolRewardDetail from '@/page/pool-reward-detail';
import UserDashboard from '@/page/user-dashboard';
import AddUserStake from '@/page/add-user-stake';
// import AddEstimateReward from '@/page/add-estimate-reward';
// import AddImageCommon from '@/page/add-image-common';
import AddUserReward from '@/page/add-user-reward';
import PointSetting from '@/page/point-setting';
import PointSettingList from '@/page/point-setting-list';
import PointSettingDetail from '@/page/point-setting/detail';
import PointSettingAccumulated from '@/page/point-setting/accumulated';
import PointUserList from '@/page/point-user-list';
import PointLedgerList from '@/page/point-user-list/PointLedgerList';
import AddUserPoint from '@/page/add-user-point';
import PointUserDetail from '@/page/point-user-detail';
import ExcelUploadPoint from '@/page/excel-upload-point';
import PointSettingAchieve from '@/page/point-setting/achieve';
import PointSettingStake from '@/page/point-setting/stake';
import PointStakingList from '@/page/point-staking-list';
import ExcelUploadPointReward from '@/page/excel-upload-point/ExcelUploadPointReward';

import SwapList from '@/page/swap-list';
import ExcelUploadBet from '@/page/excel-upload-point/ExcelUploadBet';
import Version from '@/page/version';
import VersionDetail from '@/page/version/detail';
import BetGameSettingList from '@/page/bet-game-setting/list';
import BetGameSetting from '@/page/bet-game-setting';
import BetGameSettingDetail from '@/page/bet-game-setting/detail';
import BetGameSettingCommon from '@/page/bet-game-setting/common';
import BetGameSettingJackpot from '@/page/bet-game-setting/jackpot';
import BetGameDashboard from '@/page/bet-game-dashboard';
import BetUserLedgerList from '@/page/bet-user/LedgerList';
import JackpotList from '@/page/jackpot/list';
import WinHistoryList from '@/page/win-history/list';
import AddBetPoint from '@/page/add-bet-point';
import AddJackpotPoint from '@/page/add-jackpot-point';
import AddJackpotWallet from '@/page/add-jackpot-wallet';
import ExcelUploadBetSwap from '@/page/excel-upload-point/ExcelUploadBetSwap';

// Stake-db pages
import StakeDbPoolList from '@/page/stake-db/pool-list';
import StakeDbPoolCreate from '@/page/stake-db/pool-create';
import StakeDbPoolDetail from '@/page/stake-db/pool-detail';
import StakeDbRewardPeriod from '@/page/stake-db/reward-period';
import StakeDbManualReward from '@/page/stake-db/manual-reward';
import StakeDbAddPosition from '@/page/stake-db/add-position';
import StakeDbAdminWallet from '@/page/stake-db/admin-wallet';
import StakeDbCoinType from '@/page/stake-db/coin-type';
import StakeDbDashboard from '@/page/stake-db/dashboard';

export default function RouterList() {
  return [
    {
      name: 'startPage',
      url: '/',
      element: <SignIn />,
      private: false,
    },
    {
      name: 'signIn',
      url: '/signIn',
      element: <SignIn />,
      private: false,
    },
    {
      name: 'signUp',
      url: '/sign-up',
      element: <SignUp />,
      private: false,
    },
    {
      name: 'dashboard',
      url: '/dashboard',
      element: <Dashboard />,
      private: false,
    },
    {
      name: 'AdminList',
      url: '/admin-list',
      element: <AdminList />,
      private: false,
    },

    {
      name: 'PoolList',
      url: '/pool-list',
      element: <PoolList />,
      private: false,
    },
    {
      name: 'PoolDetail',
      url: '/pool-detail',
      element: <PoolDetail />,
      private: false,
    },
    {
      name: 'PoolRewardList',
      url: '/pool-reward-list',
      element: <PoolRewardList />,
      private: false,
    },
    {
      name: 'PoolRewardList',
      url: '/pool-reward',
      element: <PoolRewardDetail />,
      private: false,
    },

    {
      name: 'FactoryDetail',
      url: '/factory-detail',
      element: <FactoryDetail />,
      private: false,
    },

    {
      name: 'CreateFactory',
      url: '/create-factory',
      element: <CreateFactory />,
      private: false,
    },

    {
      name: 'CreatePool',
      url: '/create-pool',
      element: <CreatePool />,
      private: false,
    },

    {
      name: 'FactoryList',
      url: '/factory-list',
      element: <FactoryList />,
      private: false,
    },

    {
      name: 'portfolio',
      url: '/portfolio',
      element: <PortfolioMain />,
      private: false,
    },

    {
      name: 'poolDetail',
      url: '/poolDetail',
      element: <PoolDetail />,
      private: false,
    },

    {
      name: 'pools',
      url: '/pools',
      element: <PoolMain />,
      private: false,
    },
    {
      name: 'portfolioMain',
      url: '/portfolioMain',
      element: <PortfolioMain />,
      private: false,
    },
    {
      name: 'portfolioDetail',
      url: '/portfolioDetail',
      element: <PortfolioDetail />,
      private: false,
    },
    {
      name: 'addresses',
      url: '/addresses',
      element: <Addresses />,
      private: false,
    },
    {
      name: 'user-dashboard',
      url: '/user-dashboard',
      element: <UserDashboard />,
      private: false,
    },
    {
      name: 'Add-User-Stake',
      url: '/add-user-stake',
      element: <AddUserStake />,
      private: false,
    },
    {
      name: 'Add-User-Reward',
      url: '/add-user-reward',
      element: <AddUserReward />,
      private: false,
    },

    {
      name: 'Point-Setting',
      url: '/point-setting',
      element: <PointSetting />,
      private: false,
    },

    {
      name: 'Point-Setting-List',
      url: '/point-setting-list',
      element: <PointSettingList />,
      private: false,
    },

    {
      name: 'Point-Setting-Detail',
      url: '/point-setting-detail',
      element: <PointSettingDetail />,
      private: false,
    },
    {
      name: 'Point-Setting-Accumulated',
      url: '/point-setting-accumulated',
      element: <PointSettingAccumulated />,
      private: false,
    },

    {
      name: 'Point-User-List',
      url: '/point-user-list',
      element: <PointUserList />,
      private: false,
    },

    {
      name: 'Point-User-Ledger-List',
      url: '/point-user-ledger-list',
      element: <PointLedgerList />,
      private: false,
    },

    {
      name: 'Add-User-Point',
      url: '/add-user-point',
      element: <AddUserPoint />,
      private: false,
    },

    {
      name: 'User-Detail',
      url: '/user-detail',
      element: <PointUserDetail />,
      private: false,
    },

    {
      name: 'Excel-Upload-Point',
      url: '/excel-upload-point',
      element: <ExcelUploadPoint />,
      private: false,
    },

    {
      name: 'Point-Stake-Setting',
      url: '/point-stake-setting',
      element: <PointSettingStake />,
      private: false,
    },

    {
      name: 'Point-Setting-Achieve',
      url: '/point-setting-achieve',
      element: <PointSettingAchieve />,
      private: false,
    },

    {
      name: 'Point-Staking-List',
      url: '/point-staking-list',
      element: <PointStakingList />,
      private: false,
    },

    {
      name: 'Excel-Upload-Reward',
      url: '/excel-upload-reward',
      element: <ExcelUploadPointReward />,
      private: false,
    },

    {
      name: 'Swap-List',
      url: '/swap-list',
      element: <SwapList />,
      private: false,
    },

    {
      name: 'Bet-Game-Setting-List',
      url: '/bet-game-setting-list',
      element: <BetGameSettingList />,
      private: false,
    },

    {
      name: 'Bet-Game-Setting',
      url: '/bet-game-setting',
      element: <BetGameSetting />,
      private: false,
    },
    {
      name: 'Bet-Game-Setting-Detail',
      url: '/bet-game-setting-detail',
      element: <BetGameSettingDetail />,
      private: false,
    },
    {
      name: 'Bet-Game-Setting-Common',
      url: '/bet-common-setting',
      element: <BetGameSettingCommon />,
      private: false,
    },
    {
      name: 'Bet-Game-Setting-Jackpot',
      url: '/bet-jackpot-setting',
      element: <BetGameSettingJackpot />,
      private: false,
    },
    {
      name: 'Bet-Game-Dashboard',
      url: '/bet-game-dashboard',
      element: <BetGameDashboard />,
      private: false,
    },
    {
      name: 'Bet-User-Ledger-List',
      url: '/bet-user-ledger-list',
      element: <BetUserLedgerList />,
      private: false,
    },
    {
      name: 'Jackpot-List',
      url: '/jackpot-list',
      element: <JackpotList />,
      private: false,
    },
    {
      name: 'Win-History-List',
      url: '/win-history-list',
      element: <WinHistoryList />,
      private: false,
    },
    // {
    //   name: 'Jackpot',
    //   url: '/jackpot',
    //   element: <Jackpot />,
    //   private: false,
    // },
    {
      name: 'Add-Bet-Point',
      url: '/add-bet-point',
      element: <AddBetPoint />,
      private: false,
    },
    {
      name: 'Add-Jackpot-Point',
      url: '/add-jackpot-point',
      element: <AddJackpotPoint />,
      private: false,
    },
    {
      name: 'Add-Jackpot-Wallet',
      url: '/add-jackpot-wallet',
      element: <AddJackpotWallet />,
      private: false,
    },
    {
      name: 'Excel-Upload-Bet',
      url: '/excel-upload-bet',
      element: <ExcelUploadBet />,
      private: false,
    },
    {
      name: 'Excel-Upload-Bet-swap',
      url: '/excel-upload-bet-swap',
      element: <ExcelUploadBetSwap />,
      private: false,
    },
    {
      name: 'Version-List',
      url: '/version-list',
      element: <Version />,
      private: false,
    },
    {
      name: 'Version-Detail',
      url: '/version-detail',
      element: <VersionDetail />,
      private: false,
    },
    // Stake-db routes
    {
      name: 'Stake-Db-Pool-List',
      url: '/stake-db-pool-list',
      element: <StakeDbPoolList />,
      private: false,
    },
    {
      name: 'Stake-Db-Pool-Create',
      url: '/stake-db-pool-create',
      element: <StakeDbPoolCreate />,
      private: false,
    },
    {
      name: 'Stake-Db-Pool-Detail',
      url: '/stake-db-pool-detail',
      element: <StakeDbPoolDetail />,
      private: false,
    },
    {
      name: 'Stake-Db-Reward-Period',
      url: '/stake-db-reward-period',
      element: <StakeDbRewardPeriod />,
      private: false,
    },
    {
      name: 'Stake-Db-Manual-Reward',
      url: '/stake-db-manual-reward',
      element: <StakeDbManualReward />,
      private: false,
    },
    {
      name: 'Stake-Db-Add-Position',
      url: '/stake-db-add-position',
      element: <StakeDbAddPosition />,
      private: false,
    },
    {
      name: 'Stake-Db-Admin-Wallet',
      url: '/stake-db-admin-wallet',
      element: <StakeDbAdminWallet />,
      private: false,
    },
    {
      name: 'Stake-Db-Coin-Type',
      url: '/stake-db-coin-type',
      element: <StakeDbCoinType />,
      private: false,
    },
    {
      name: 'Stake-Db-Dashboard',
      url: '/stake-db-dashboard',
      element: <StakeDbDashboard />,
      private: false,
    },
    // {
    //   name: 'Add-Estimate-Reward',
    //   url: '/add-estimate-reward',
    //   element: <AddEstimateReward />,
    //   private: false,
    // },
    // {
    //   name: 'Add-Image-common',
    //   url: '/add-image-common',
    //   element: <AddImageCommon />,
    //   private: false,
    // },
  ];
  // return LinkList;
}
